import { render } from "./Mixed.vue?vue&type=template&id=32af2294&ts=true"
import script from "./Mixed.vue?vue&type=script&lang=ts"
export * from "./Mixed.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__